export enum ObjectTypes {
  // Building,
  // Trench,
  // Duct,
  // Cable,
  // Floor,
  // Room,
  // Rack,
  // Component,
  // ComponentPort,
  // PLP,
  // Fiber,
  // Service,
  Bauwerk,
  Trasse,
  Rohr,
  Kabel,
  Etage,
  Raum,
  Schrank,
  Komponente,
  Port,
  NeuesObjekt,
  Faser,
  Dienst
}
export enum ObjectTypesen {
  Building,
  Trench,
  Duct,
  Cable,
  Floor,
  Room,
  Rack,
  Component,
  ComponentPort,
  NewObject,
  Fiber,
  Service
}
